import styled from 'styled-components'
import { SpecialButton } from '@chegg-wt/core/theme/fanta/button'
import { colors, font } from '@chegg-ui/theme'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import { Config } from '@chegg-wt/core/config'

export const FreeTrialCTA = styled(SpecialButton)`
  margin: auto 24px;
  min-height: 30px;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    font-size: ${font.size.px12} !important;
    line-height: initial;
  }
`

export const BoldText = styled.div`
  font-size: ${FantaTheme.font.text.size.lg};
  font-weight: ${FantaTheme.font.weight.bold};
`

export const Banner = styled.div<{
  fullBanner: boolean
}>`
  display: flex;
  flex-direction: row;
  background-color: ${colors.skyLight};
  justify-content: center;
  align-items: center;
  text-align: center;

  width: 100%;
  min-height: '72px';
  padding: ${FantaTheme.spacing.fanta.sm};
  font-size: ${FantaTheme.font.text.size.md};
  line-height: 1.25rem;
  border-radius: ${({ fullBanner }) => (fullBanner ? '0px' : '20px')};
  margin: ${({ fullBanner }) =>
    // eslint-disable-next-line no-nested-ternary
    fullBanner
      ? Config.appName === 'ctfm'
        ? '5px 5px 0px 0px'
        : '0px 5px 0px 0px'
      : '5px auto'};
`
